import { call, put, takeEvery } from "redux-saga/effects";
import transportService from "services/transportService";
import {
  GET_LIST_TRANSPORT_GROUP,
  getListTransportGroupFail,
  getListTransportGroupSuccess,
} from "./actions";

function* getTransportGroupList(action) {
  try {
    const response = yield call(
      transportService.getTransportGroup,
      action.payload
    );
    if (response?.status === 200) {
      yield put(getListTransportGroupSuccess(response.data));
    } else {
      yield put(getListTransportGroupFail("Get list fail"));
    }
  } catch (error) {
    yield put(getListTransportGroupFail(error));
  }
}

function* ProfileSaga() {
  yield takeEvery(GET_LIST_TRANSPORT_GROUP, getTransportGroupList);
}

export default ProfileSaga;
